
  import { defineComponent, PropType } from 'vue';

  import { SHOW_SECTION_FILTER_OPTIONS } from '../../constants/options';
  import { ShowSections } from '../../types/common-aggregated';
  import FTSFilterWrapperRadio from './fts-filter/FTSFilterWrapperRadio.vue';

  export default defineComponent({
    name: 'FTSSectionField',
    components: { FTSFilterWrapperRadio },
    props: {
      modelValue: {
        type: Number as PropType<ShowSections>,
        required: true,
      },
    },
    emits: ['update:modelValue'],
    computed: {
      sectionAccessor: {
        get() {
          return this.modelValue;
        },
        set(newValue: ShowSections) {
          this.$emit('update:modelValue', newValue);
        },
      },
      getWeightOptions() {
        return SHOW_SECTION_FILTER_OPTIONS;
      },
    },
  });
